import { Button, Grid, HStack, Text, Textarea } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Input,
  FormLabel,
  Box,
  Flex,
} from "@chakra-ui/react";
import "../Programs.scss";
import Edit from "../../../assets/iconz/edit.png";
import Del from "../../../assets/iconz/trash-2.svg";
import { useDropzone } from "react-dropzone";
import "../Programs.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTh } from "@fortawesome/free-solid-svg-icons";

const Content = ({ formHandler }) => {
  const [lesson, setLesson] = useState({
    title: "",
    objective: "",
    link: "",
    file: "",
    fileUpload: "",
  });
  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    onDrop: (acceptedFiles) => {
      setLesson((prevFiles) =>
        acceptedFiles.reduce(
          (acc, file) => ({
            ...acc,
            file: file.name,
            fileUpload: URL.createObjectURL(file),
          }),
          prevFiles
        )
      );
    },
    // accept: ".doc",
  });

  const [data, setData] = useState([]);
  const [index, setIndex] = useState();
  const [editing, setEditing] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  // the data is an array of objects in the lesson data format, this useEffect block assigns the current data from the formik object into the state, and the app displays it to the user... this is useful when editing the program's contents
  useEffect(() => {
    setData(formHandler.values.content);
  }, [formHandler.values.content]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLesson({
      ...lesson,
      [name]: value,
    });
  };

  // delete a particular program from the DOM and update into formik
  const handleDelete = (index) => {
    let copyOfData = [...data];
    copyOfData.splice(index, 1);
    setData(copyOfData);
    formHandler.values.content = copyOfData;
  };

  // Opens a modal to edit the program data, and sets the selected program data intos state
  const handleEdit = (dataToEdit, index) => {
    setEditing(true);
    onOpen();
    setLesson({
      title: dataToEdit.title,
      objective: dataToEdit.objective,
      file: {
        name: dataToEdit.file.name,
        link: dataToEdit.file.link,
      },
    });
    setIndex(index);
  };

  // use the data at the selected index in formik, then the useEffect hook updates the state
  const updateLesson = () => {
    // update data for the index to be edited
    formHandler.values.content[index] = {
      title: lesson.title,
      objective: lesson.objective,
      file: {
        name: lesson.file.name,
        link: lesson.file.link,
      },
    };

    onClose();
  };

  // This updates the formik data for the object field, the useEffect hooks runs after all changes on the content data, it updates the ui
  // Then reset the state of the lesson
  const saveLesson = () => {
    // update formkik content's data
    let prevContents = formHandler.values.content;
    formHandler.values.content = [...prevContents, lesson];

    setLesson({
      title: "",
      objective: "",
      link: "",
      file: {
        link: lesson.file.link,
        name: lesson.file.name,
      },
    });
  };

  const handleSubmit = () => {
    if (editing) {
      updateLesson();
    } else {
      saveLesson();
    }
    onClose();
  };

  // const handleFileUpload = (e) => {
  //   if (e.target.files.length) {
  //     setLesson({
  //       ...lesson,
  //       file: {
  //         // link: URL.createObjectURL(e.target.files[0]),
  //         link: "",
  //         name: e.target.files[0].name,
  //       },
  //     });
  //   }
  // };

  return (
    <div>
      <h2>Curriculum</h2>
      <Flex justify="space-between" align="center" my={3}>
        <Text fontSize="22px">Lessons</Text>
        <Button
          colorScheme="green"
          color="white"
          onClick={() => {
            onOpen();
            setEditing(false);
            setLesson({
              title: "",
              objective: "",
              file: {
                name: "lesson1.docx",
                link: "#",
              },
            });
          }}
        >
          Add a lesson
        </Button>
      </Flex>

      <div style={{ textAlign: "end" }}>
        {data &&
          data.map((data, idx) => (
            <Grid templateColumns="1fr auto">
              <Flex
                // templateColumns="50% 30% 20%"
                my={3}
                // justifyItems="start"
                justify="space-between"
                className="singleCurriculum"
                py={4}
                px={6}
                key={`lesson${idx}`}
              >
                <h1>{data.title}</h1>
                <HStack spacing={4}>
                  <Text href={data.file.link}>{data.file.name}</Text>
                  <Box sx={{ cursor: "pointer" }}>
                    <FontAwesomeIcon icon={faTh} />
                  </Box>
                </HStack>
              </Flex>

              <HStack ml="4" align="center">
                <img
                  src={Edit}
                  className="edit"
                  alt="edit"
                  onClick={() => handleEdit(data, idx)}
                />
                <img
                  src={Del}
                  className="del"
                  onClick={() => handleDelete(idx)}
                  alt="del"
                />
              </HStack>
            </Grid>
          ))}
      </div>
      <Modal isOpen={isOpen} onClose={onClose} w="90%">
        <ModalOverlay />
        <ModalContent as="form" onSubmit={handleSubmit}>
          <ModalHeader>{editing ? "Edit Lesson" : "New Lesson"}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box mt={4}>
              <FormLabel htmlFor="title">Program Title</FormLabel>
              <Input
                variant="filled"
                id="title"
                type="text"
                name="title"
                placeholder="Enter Title"
                size="lg"
                onChange={handleChange}
                value={lesson.title}
                isRequired
              />
            </Box>
            <Box mt={4}>
              <FormLabel htmlFor="title">Objectives</FormLabel>
              <Textarea
                variant="filled"
                id="objectives"
                type="text"
                name="objective"
                placeholder="Enter Objectives"
                size="lg"
                onChange={handleChange}
                value={lesson.objective}
                isRequired
              />
            </Box>
            <Box mt={4}>
              <FormLabel htmlFor="title">Content Link</FormLabel>
              <Input
                variant="filled"
                id="link"
                type="text"
                name="link"
                disabled
                placeholder="https://"
                size="lg"
                onChange={handleChange}
                value={lesson.file.link}
              />
            </Box>
            <section className="file-container">
              <div {...getRootProps({ className: "dropzone" })}>
                <input
                  {...getInputProps()}
                  type="file"
                  // onChange={handleFileUpload}
                />
                <p>Click to select file or drag file to upload </p>
              </div>
              <aside>
                <h4>Selected File</h4>
                <ul>{lesson.file.name}</ul>
              </aside>
            </section>
          </ModalBody>

          <ModalFooter>
            {!editing && (
              <Button bg="#213C5C" color="white" type="submit">
                Save
              </Button>
            )}

            {editing && (
              <Button colorScheme="green" color="white" type="submit">
                Update
              </Button>
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default Content;
